export default __webpack_public_path__ + "static/media/invoice-icon.2bf8226d.svg";